import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="text-center py-16">
      <h1 className="text-2xl mb-4 text-[var(--dispensary-gray-700)]">
        Product Not Found
      </h1>
      <p className="mb-8">
        The product you're looking for doesn't exist or has been removed.
      </p>
      <Button onClick={() => navigate('/')}>Return to Homepage</Button>
    </div>
  );
}
